export const CMS = {
  NEWS: "news",
  EDUCATION: "education",
  DOCUMENTS: "documents",
  HELP: "help",
  BANNERS: "banners",
};
